// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 0px) and (max-width: 767px) {
  .login_page_logo_container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 80%;
  }
  .container form {
    background: linear-gradient(to right, #c33764, #1d2671) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 10px;
    height: 100%;
  }
  .sign_up_input {
    width: 270px !important;
  }
  .view-text {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    color: #ffffff;
    margin-top: 40px;
  }

  .container input {
    background-color: #eee;
    border: none;
    margin: 8px 0;
    font-size: 13px;
    border-radius: 8px;
    width: 100%;
    outline: none;
  }
  .form-container sign-in {
    background: linear-gradient(to right, #c33764, #1d2671) !important;
  }
  .sing_in_text {
    color: #ffffff;
  }
  .forgot_password_text {
    color: #ffffff;
    font-size: 12px;
  }

  .container.active .sign-up {
    transform: translateX(0%);
    transition: all 0.6s ease-in-out;
    background: linear-gradient(to right, #c33764, #1d2671) !important;
  }
  .otp_text {
    color: #ffff;
  }
  .resent_otp_text {
    color: #ffff;
  }
  .sing_in_text_underline {
    color: white !important;
    text-decoration: underline !important;
  }
  .forgot_password_send_mail {
    margin: 1vh 4vh 1vh 7vh;
    color: #ffffff !important;
  }

}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_767/screen_767_login.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;EACZ;EACA;IACE,kEAAkE;IAClE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,YAAY;EACd;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;EACA;IACE,kEAAkE;EACpE;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;IAChC,kEAAkE;EACpE;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,qCAAqC;EACvC;EACA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;AAEF","sourcesContent":["@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .login_page_logo_container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 80%;\n  }\n  .container form {\n    background: linear-gradient(to right, #c33764, #1d2671) !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 0 10px;\n    height: 100%;\n  }\n  .sign_up_input {\n    width: 270px !important;\n  }\n  .view-text {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: center;\n    color: #ffffff;\n    margin-top: 40px;\n  }\n\n  .container input {\n    background-color: #eee;\n    border: none;\n    margin: 8px 0;\n    font-size: 13px;\n    border-radius: 8px;\n    width: 100%;\n    outline: none;\n  }\n  .form-container sign-in {\n    background: linear-gradient(to right, #c33764, #1d2671) !important;\n  }\n  .sing_in_text {\n    color: #ffffff;\n  }\n  .forgot_password_text {\n    color: #ffffff;\n    font-size: 12px;\n  }\n\n  .container.active .sign-up {\n    transform: translateX(0%);\n    transition: all 0.6s ease-in-out;\n    background: linear-gradient(to right, #c33764, #1d2671) !important;\n  }\n  .otp_text {\n    color: #ffff;\n  }\n  .resent_otp_text {\n    color: #ffff;\n  }\n  .sing_in_text_underline {\n    color: white !important;\n    text-decoration: underline !important;\n  }\n  .forgot_password_send_mail {\n    margin: 1vh 4vh 1vh 7vh;\n    color: #ffffff !important;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
